// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { cronosTestnet as _cronosTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the cronosTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 338
 * Chain Name: Cronos Testnet
 * Default Block Explorer: https://cronos.org/explorer/testnet3
 * Default RPC URL: https://evm-t3.cronos.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { cronosTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: cronosTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const cronosTestnet = createCommon({
	..._cronosTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
